import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Instagram } from "lucide-react";

export default function Newsletter({ source = "footer", dark = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const res = await api.post("/subscribers", { email, source });
      toast.success(res.data.message || "You're subscribed. Thank you.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 w-full max-w-md" data-testid="newsletter-form">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        data-testid="newsletter-email-input"
        className={`flex-1 px-4 py-3 rounded-md border outline-none transition-colors ${
          dark
            ? "bg-white/10 border-white/20 text-footer-fg placeholder:text-footer-fg/50 focus:border-gold"
            : "bg-surface-card hairline border text-earth placeholder:text-earth/40 focus:border-gold"
        }`}
      />
      <button type="submit" disabled={busy} className="btn-gold text-sm whitespace-nowrap" data-testid="newsletter-submit-btn">
        {busy ? "…" : "Subscribe"}
      </button>
    </form>
  );
}

export { Instagram };
